export const STICKY_COLORS = [
  '#fff9b1', // yellow
  '#f5d128', // dark yellow
  '#ffd2a8', // orange
  '#ff9d48', // dark orange
  '#ffc6e0', // pink
  '#ea94bb', // magenta
  '#c9df56', // light green
  '#93d275', // green
  '#a6ccf5', // light blue
  '#6cd8fa', // cyan
  '#c6b2f5', // violet
  '#e6e6e6', // gray
] as const;

/** Colors for strokes, text and fills (first entries are neutral). */
export const BASE_COLORS = [
  '#1a1a2e',
  '#ffffff',
  '#6b7280',
  '#ef4444',
  '#f97316',
  '#eab308',
  '#22c55e',
  '#14b8a6',
  '#3b82f6',
  '#6366f1',
  '#a855f7',
  '#ec4899',
] as const;

export const FILL_COLORS = ['transparent', ...BASE_COLORS.slice(1)] as const;

/** Colors assigned to users (cursors, avatars). */
export const USER_COLORS = [
  '#ef4444',
  '#f97316',
  '#eab308',
  '#22c55e',
  '#14b8a6',
  '#0ea5e9',
  '#6366f1',
  '#a855f7',
  '#ec4899',
  '#84cc16',
] as const;

export function pickUserColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  return USER_COLORS[Math.abs(hash) % USER_COLORS.length]!;
}
